import { render, staticRenderFns } from "./ai-tizhiceping.vue?vue&type=template&id=880f75de&scoped=true"
import script from "./ai-tizhiceping.vue?vue&type=script&lang=ts"
export * from "./ai-tizhiceping.vue?vue&type=script&lang=ts"
import style0 from "./ai-tizhiceping.vue?vue&type=style&index=0&id=880f75de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880f75de",
  null
  
)

export default component.exports